import { render } from "./creditors-receipt.vue?vue&type=template&id=239cec94&scoped=true"
import script from "./creditors-receipt.vue?vue&type=script&lang=js"
export * from "./creditors-receipt.vue?vue&type=script&lang=js"

import "./creditors-receipt.vue?vue&type=style&index=0&id=239cec94&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239cec94"]])

export default __exports__